import { PopoverPlacement } from "@idui/react-popover";
import { Checkbox, FormControlLabel } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { formatAvoidTollsDefaultBadge, useIsMobile } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import { REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS } from "./rebuild-route-dropdown.constants";

interface IRebuildRouteDropdownAvoidTollsRowProps {
  checked: boolean;
  isDefaultAvoidTolls: boolean;
  onChange: (checked: boolean) => void;
}

export const RebuildRouteDropdownAvoidTollsRow: FC<
  IRebuildRouteDropdownAvoidTollsRowProps
> = ({ checked, isDefaultAvoidTolls, onChange }) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const matchesDefault = checked === isDefaultAvoidTolls;
  const defaultBadgeClassName = matchesDefault
    ? "rebuild-route-dropdown-avoid-tolls-badge rebuild-route-dropdown-avoid-tolls-badge--matches"
    : "rebuild-route-dropdown-avoid-tolls-badge rebuild-route-dropdown-avoid-tolls-badge--mismatch";
  const badgeLabel = formatAvoidTollsDefaultBadge({
    matchesDefault,
    defaultAvoidTolls: isDefaultAvoidTolls,
    t,
  });
  const badge = (
    <span
      className={defaultBadgeClassName}
      data-e2e="avoid-tolls-default"
      tabIndex={isMobile ? undefined : 0}
    >
      {badgeLabel}
    </span>
  );

  return (
    <div className="rebuild-route-dropdown-avoid-tolls-row">
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={checked}
            onChange={event => onChange(event.target.checked)}
          />
        }
        label={
          <span className="rebuild-route-dropdown-avoid-tolls-label">
            {t("general.AVOID_TOLLS")}
            {isMobile ? (
              badge
            ) : (
              <FramerTooltip
                content={t("general.AVOID_TOLLS_DEFAULT_TOOLTIP")}
                placement={PopoverPlacement.top}
                mouseEnterDelay={
                  REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS
                }
              >
                {badge}
              </FramerTooltip>
            )}
          </span>
        }
        className="rebuild-route-dropdown-option-item"
      />
    </div>
  );
};
